import React from 'react';
import style from './style/modalheader.scss';

/**
 * Modal Header
 * - Provides header for use inside the Modal component
 *  - renders provided children
 * - allows style overrides
 * @param {Object} props - props
 * @returns {*} Index
 * */
export default function ModalHeader(props) {
    const { children, classes = { modalHeader: '' } } = props;

    return (
        <div className={ `${style.modalHeader} ${classes.modalHeader}` }>
            { children }
        </div>
    );
}
